const styles = () => ({
  questionWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  answer: {
    textAlign: "center",
    width: "100%",
  },
  field: {
    width: "99%",
  },
  textBottomContainer: {
    display: "flex",
    justifyContent: "flex-end",
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: 13,
    marginTop: "-7px",
    width: "99%",
  },
  helperText: {
    flexGrow: 50,
  },
  limitWarning: {
    color: "#c53929",
  },
  counterBox: {
    marginLeft: 15,
    minWidth: 49,
    textAlign: "right",
  },
  textArea: {
    width: "100%",
    minHeight: "100px !important",
    borderRadius: 4,
    border: "1px solid #dadce0",
    paddingLeft: 10,
    fontSize: 16,
    "&:focus": {
      outline: "none !important",
      border: (props) => `1px solid ${props.currentTheme.primaryColor}`,
    },
  },
});

export default styles;
